const gridUnit = 4;

export function gUnit(multiplier: number): number {
  return multiplier * gridUnit;
}

export default {
  gUnit,
};
